import React, { useEffect, useState } from 'react';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import { useFormikContext } from 'formik';
import Styles from './companyDetails.module.css';
import get from 'lodash/get';
import {
  getBusinessAddress,
  confirmBusinessAddress
} from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import * as _ from 'lodash';
import PopUp from '../../../common/components/PopUp/PopUp';

const { current_address } = Styles;

const AddCompanyAddress = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  useEffect(() => {
    setType('loading');
    setText('Getting Details Please Wait...');
    setShow(true);

    getBusinessAddress(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        if (res.error) {
          throw new Error(resetWarningCache);
        }
        if (res) {
          setFieldValue(
            'address',
            `${_.get(
              res,
              'leadKycPresignedUrlResponseDto.userData.address.line1',
              ' '
            )}, ${_.get(
              res,
              'leadKycPresignedUrlResponseDto.userData.address.line2',
              ' '
            )}, ${_.get(
              res,
              'leadKycPresignedUrlResponseDto.userData.address.city',
              ' '
            )}, ${_.get(
              res,
              'leadKycPresignedUrlResponseDto.userData.address.state',
              ' '
            )}
       -${_.get(
         res,
         'leadKycPresignedUrlResponseDto.userData.address.pinCode',
         ' '
       )}`
          );
          setFieldValue('source', _.get(res, 'source', ''));
          setFieldValue('preAddress', true);
        } else {
          handleSubmit();
        }
        setShow(false);
      })
      .catch(error => {
        setShow(false);
      });
  }, []);
  const confirmTheCurrentAddress = () => {
    setType('loading');
    setText('Submitting Please Wait...');
    setShow(true);

    confirmBusinessAddress(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        handleSubmit();
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  };
  const handleSubmition = () => {
    if (values.currentAddress == 'yes') {
      confirmTheCurrentAddress();
    } else {
      handleSubmit();
    }
  };

  return (
    <React.Fragment>
      <div className="w-full md:px-10  px-4">
        <p className="font-roboto font-medium md:text-black-850 text-black-400 mt-4 md:text-base text-sm flex ">
          <span className="hidden md:block mr-2">
            {values.step == 'sep' ? 'Business ' : 'Company '}{' '}
          </span>{' '}
          Address
        </p>

        <div
          className={`bg-grey-900 md:bg-grey-0 py-3 w-full lg:w-7/12  mr-auto my-3 border border-navy-200 h-full py-1 px-2 rounded-lg flex pb-10 ${current_address}`}
        >
          <div className="w-1/12 ">
            <LocationOnOutlinedIcon
              style={{ color: 'grey', width: '25px', height: '25px' }}
            />
          </div>
          <div className="w-8/12 text-left px-3">
            <p className="font-roboto font-normal text-grey-1200 text-sm mr-auto">
              {values.step == 'sep' ? 'Permanent Adddress' : 'Address 1'}
            </p>
            <p className="font-roboto font-normal text-black-400 text-xs py-1">
              {values.address}
            </p>
          </div>
          <div className="w-5/12 items-start ml-auto text-right">
            <p
              className="font-roboto font-normal text-black-400 text-xs  ml-auto"
              style={{ fontSize: '10px' }}
            >
              Source : {values.source}
            </p>
          </div>
        </div>
      </div>
      <div className="w-full  px-5 md:px-10 my-3 md:my-10">
        <p className="font-roboto  md:text-grey-2000 md:text-sm text-base text-black-850 font-medium md:font-normal">
          {values.step == 'sep'
            ? 'Is this your business address?'
            : 'Is your registered address and business address is same?'}
        </p>
        <div className="w-full md:flex block py-3">
          <div className="flex-row-reverse flex md:flex-row ">
            <RadioButton
              name="currentAddress"
              value={values.currentAddress == 'yes' ? true : false}
              checked={values.currentAddress == 'yes' ? true : false}
              onChange={e => {
                handleChange(e), setFieldValue('currentAddress', 'yes');
              }}
              onBlur={handleBlur}
            />
            <p className="font-roboto font-normal text-grey-2000 md:px-3 mr-auto">
              Yes
            </p>
          </div>
          <div className="mr-auto flex md:ml-10 flex-row-reverse md:flex-row py-2 md:py-0 mt-3 md:mt-0">
            <RadioButton
              name="currentAddress"
              value={values.currentAddress == 'no' ? true : false}
              checked={values.currentAddress == 'no' ? true : false}
              onChange={e => {
                handleChange(e), setFieldValue('currentAddress', 'no');
              }}
              onBlur={handleBlur}
            />
            <p className="font-roboto font-normal text-grey-2000 md:px-3  mr-auto">
              No
            </p>
          </div>
        </div>
        <button
          type="button"
          className="submitButton font-roboto text-white text-base w-48 "
          onClick={handleSubmition}
          disabled={Object.keys(errors).length != 0 ? true : false}
        >
          NEXT
        </button>
      </div>{' '}
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </React.Fragment>
  );
};

export default AddCompanyAddress;
